//@ts-check
import React, { useState } from 'react';
import { useUnit } from 'hooks/units/index';
import { UNIT_STATUS } from 'constants/constants';
import ButtonCompleted from '../Complete/ButtonCompleted';
import ThemeButton from 'components/AntdFormInputs/theme-button';

import { handleToastError, parseHtml } from 'helpers';
import adaptiveApi from 'api/adaptiveAiApi';
import { useDispatch, useSelector } from 'react-redux';
import { completeUnitAsync, fetchUnitAsync } from 'store/units';
import { getSelectedCentre } from 'store/master';
import useI18n from 'hooks/use-i18n';
import { useRouter } from 'next/router';
import { showToastSuccess } from '@core/components/toastify/ToastTypes';
import { Divider } from 'antd';
import TrackingResultAdaptive from './TrackingResultAdaptive';

const AdaptiveButton = () => {
  const i18n = useI18n();
  const unitSelected = useUnit();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const isCompleted = unitSelected.status === UNIT_STATUS.COMPLETED;
  const isPending = unitSelected.status === UNIT_STATUS.PENDING;
  const isActive = unitSelected.status === UNIT_STATUS.ACTIVE;
  const isIncompleted = unitSelected.status === 'INCOMPLETED';

  const handleStartQuestion = async () => {
    try {
      setIsLoading(true);

      const response = await adaptiveApi.startAdaptiveAiUnitQuestion(
        unitSelected._id,
      );

      await fetchUnitAsync(unitSelected._id)(dispatch);

      if (response?._id) {
        showToastSuccess('Adaptive learning started successfully');
      }
    } catch (error) {
      console.error(error);
      handleToastError(error, i18n);
    } finally {
      setIsLoading(false);
    }
  };

  if (isCompleted || isIncompleted) {
    return (
      <TrackingResultAdaptive isBusy={false} unitSelected={unitSelected} />
    );
  }

  if (isPending) {
    return null;
  }

  if (isActive) {
    return (
      <div className="text-center my-05">
        <Divider className="my-2" />
        <ThemeButton
          padding="7px 18px"
          className="rounded-pill"
          onClick={handleStartQuestion}
          isLoading={isLoading}
        >
          Start
        </ThemeButton>
      </div>
    );
  }

  return null;
};

export default AdaptiveButton;
